import React from 'react';
import "./SocialIcons.Style.scss";
import {FormattedMessage} from "react-intl";

const SocialIcons = ({t}) => {
    return (
        <div className="social-col">
            <span className="social">
              <p><FormattedMessage id={"footer.followUs"} /></p> &nbsp;
                {/*<a href="https://m.facebook.com/profile.php?id=100069599064875&_rdr" target="_blank"
                   rel="noreferrer"><i className="fa-brands fa-facebook-f" /></a>*/}
                <a href="https://www.instagram.com/pickxfan/" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"/></a>
                <a href="https://x.com/pickxfan" target="_blank" rel="noreferrer"><i className="icons twitter-x"/></a>
            </span>
        </div>
    )
}

export default SocialIcons;